import { render, staticRenderFns } from "./NewsModule.vue?vue&type=template&id=9f2bd6d6&scoped=true"
import script from "./NewsModule.vue?vue&type=script&lang=js"
export * from "./NewsModule.vue?vue&type=script&lang=js"
import style0 from "./NewsModule.vue?vue&type=style&index=0&id=9f2bd6d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2bd6d6",
  null
  
)

export default component.exports